import { render, staticRenderFns } from "./faqDetail.vue?vue&type=template&id=276e6d08&scoped=true"
import script from "./faqDetail.vue?vue&type=script&lang=js"
export * from "./faqDetail.vue?vue&type=script&lang=js"
import style0 from "./faqDetail.vue?vue&type=style&index=0&id=276e6d08&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "276e6d08",
  null
  
)

export default component.exports